export default __webpack_public_path__ + "7617179f2a51f9265df9b4a470d1a38e.svg";